/**
 * Specifies the type of business event related to an algo certification request.
 * - Tag: 3077
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const AlgoCertificateRequestType = Object.freeze({
    CertificateInformation: 0,
    GenerateCertificate: 1,
    ChangeCertificateStatus: 2,
    ForwardCertificate: 3,
} as const);

export type AlgoCertificateRequestType = (typeof AlgoCertificateRequestType)[keyof typeof AlgoCertificateRequestType];
